export function isDOMText(data: any): boolean {
  return typeof data === 'string';
}
